import { combineReducers } from 'redux';
const OBJECT = 'object';

class ReducerStore {

    constructor () {
        this.reducers = {};
    }

    add (moreReducers) {
        const allReducers = this.reducers;
        if (typeof moreReducers === OBJECT) {
            Object.assign(allReducers, moreReducers);
        }
        return allReducers;
    }

    combine () {
        return combineReducers(this.reducers);
    }

}
export default ReducerStore;
